import React, { forwardRef } from 'react'
import { CommonButton, CommonButtonProps } from './common-button'
import { ButtonTypeEnum, ButtonSizeEnum } from './enums'

export interface ButtonWithTypeProps
  extends Omit<CommonButtonProps, 'type' | 'icon'> {
  children: React.ReactNode
}

export const PrimaryButton = forwardRef<HTMLButtonElement, ButtonWithTypeProps>(
  ({ ...props }, ref) => (
    <CommonButton
      ref={ref}
      type={ButtonTypeEnum.Primary}
      size={ButtonSizeEnum.Medium}
      {...props}
    />
  ),
)

export const SecondaryButton = forwardRef<
  HTMLButtonElement,
  ButtonWithTypeProps
>(({ ...props }, ref) => (
  <CommonButton
    ref={ref}
    type={ButtonTypeEnum.Secondary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
))

export const TertiaryButton = forwardRef<
  HTMLButtonElement,
  ButtonWithTypeProps
>(({ ...props }, ref) => (
  <CommonButton
    ref={ref}
    type={ButtonTypeEnum.Tertiary}
    size={ButtonSizeEnum.Medium}
    {...props}
  />
))

export const GhostButton = forwardRef<HTMLButtonElement, ButtonWithTypeProps>(
  ({ ...props }, ref) => (
    <CommonButton
      ref={ref}
      type={ButtonTypeEnum.Ghost}
      size={ButtonSizeEnum.Small}
      {...props}
    />
  ),
)

export const TextButton = forwardRef<HTMLButtonElement, ButtonWithTypeProps>(
  ({ ...props }, ref) => (
    <CommonButton
      ref={ref}
      type={ButtonTypeEnum.Text}
      size={ButtonSizeEnum.Small}
      {...props}
    />
  ),
)
